module.exports = __webpack_public_path__ + "img/img96.88e03941.svg";